import "./AgencyInstitutionWing.module.css";
import Header from "@/reusable_sections/Header";
import DarkHeroBreadcrumbs from "./sections/DarkHeroBreadcrumbs";
import ZonaPPProfileDirectory from "./sections/ZonaPPProfileDirectory";
import ServiceBenefitsGrid from "./sections/ServiceBenefitsGrid";
import Footer from "@/reusable_sections/Footer";
export default function AgencyInstitutionWingPage() {
  return <div>
      <Header />
      <DarkHeroBreadcrumbs />
      <ZonaPPProfileDirectory />
      <ServiceBenefitsGrid />
      <Footer />
    </div>;
}